import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  API_STATUS_REQ_CREATE,
  API_STATUS_REQ_UPDATE,
} from '../../services/api';
import {
  changeCoordenadorEditingValue,
  clearCoordenadorEditing,
  loadCoordenadorByCPF,
  saveCoordenadorByCPF,
} from '../../store/modules/CoordenadoresActions';
import {
  loadCidadesByEstadoId,
  loadCooperativas,
  loadEstados,
} from '../../store/modules/LogradouroActions';
import { closeModal } from '../../store/modules/ModalActions';
import {
  getElementID,
  getInputFocusInFocusOutAttr,
} from '../../utils/HTMLUtils';
import { getUnmaskedValue } from '../../utils/InputMaskUtils';
import {
  allIsTrue,
  celularIsValid,
  cpfIsValid,
  doubleNameIsValid,
  emailIsValid,
  EMAIL_MAX_LENGTH,
  estadoRequiredIsValid,
  maskedValueRequiredIsValid,
  NOME_MAX_LENGTH,
  requiredIsValid,
  strCidadeRequiredIsValid,
  dateIsValid,
} from '../../utils/ValidationUtils';
import { CustomTextField } from '../CustomTextField';
import RefreshIcon from '../Icons/RefreshIcon';
import SaveIcon from '../Icons/SaveIcon';
import {
  CPFMaskedInput,
  DateMaskedInput,
  PhoneMaskedInput,
} from '../MaskedInputs';
import NewAutoCompleteField from '../NewAutoCompleteField/NewAutoCompleteField';
import { Col } from './../Col';
import { CustomButton } from './../CustomButton';
import { Row } from './../Row';
import styles from './CoordenadorEditModal.scss';
import { GenericModalCadastro } from 'components/GenericModal/GenericModalCadastro';
import { NewAutoCompleteFieldEstados } from 'components/NewAutoCompleteField/NewAutoCompleteFieldEstados';
import { NewAutoCompleteFieldCidades } from 'components/NewAutoCompleteField/NewAutoCompleteFieldCidades';

const rootClassName = styles.rootClassName;
const rootElementId = 'coordenador-edit-modal';

const INITIAL_STATE = {
  open: false,
  saving: false,
  loading: false,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,

  nomeChanged: false,
  celularChanged: false,
  emailChanged: false,
  dataNascimentoChanged: false,
  cpfChanged: false,
  coopChanged: false,
  estadoChanged: false,
  cidadeChanged: false,

  focusedFieldName: null,
};

class CoordenadorEditModal extends Component {
  validations = {
    nomeIsValid: { status: false },
    celularIsValid: { status: false },
    emailIsValid: { status: false },
    dataNascimentoIsValid: { status: false },
    cpfIsValid: { status: false },
    coopIsValid: { status: false },
    estadoIsValid: { status: false },
    cidadeIsValid: { status: false },
  };

  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };

    this.setValue = this.setValue.bind(this);
    this.focusIn = this.focusIn.bind(this);
    this.focusOut = this.focusOut.bind(this);
  }

  changeState(newState) {
    this.setState({
      ...this.state,
      ...newState,
    });
  }

  getUFByIdEstado(idEstado) {
    const estados = this.props.logradouro.estados.filter(estado => estado.id === idEstado);
    return (estados && estados.length > 0) ? estados[0].sigla : '';
  }

  getEstadoByIdEstado(idEstado) {
    const estados = this.props.logradouro.estados.filter((estado) => {
      if (estado.id === idEstado) {
        return true;
      }
      return false;
    });
    if (estados && estados.length > 0) {
      return estados[0].nome;
    }
    return '';
  }

  getCidades(uf) {
    if (!uf || uf.length === 0) {
      return [];
    }
    return this.props.logradouro.cidades[uf.toLowerCase()] || [];
  }

  loadCidades(idEstado) {
    if (this.getCidades(this.getUFByIdEstado(idEstado)).length === 0) {
      this.props.loadCidadesByEstadoId(
        idEstado,
        this.getUFByIdEstado(idEstado)
      );
    }
  }

  fieldDisabled() {
    return this.state.saving === true || this.state.loading === true
      ? true
      : false;
  }

  reset() {
    this.setState(INITIAL_STATE);
    this.props.clearCoordenadorEditing();
  }

  componentWillUnmount() {
    this.reset();
  }

  UNSAFE_componentWillMount() {
    let currState = INITIAL_STATE;

    if (this.editing()) {
      currState = {
        ...currState,
        open: true,
        loading: true,
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
      };
      this.props.loadCoordenadorByCPF(
        this.props.cpf,
        () => {
          this.formIsValid(true);
          this.changeState({
            loading: false,
            nomeChanged: true,
            emailChanged: true,
            maeChanged: true,
            dataNascimentoChanged: true,
            rgChanged: true,
            cpfChanged: true,
            coopChanged: true,
            estadoChanged: true,
            cidadeChanged: true,
            disableBackdropClick: false,
            disableEscapeKeyDown: false,
          });
          if (this.props.coordenadores.coordenadorEditing.idEstado > -1) {
            this.loadCidades(
              this.props.coordenadores.coordenadorEditing.idEstado
            );
          }
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorLoadCoordenadorEditing,
            options: {
              variant: 'error',
            },
          });
          this.toClose();
        }
      );
    }

    this.props.loadCooperativas();

    if (
      !this.props.logradouro.estados ||
      this.props.logradouro.estados.length === 0
    ) {
      this.props.loadEstados(() => {
        if (this.props.coordenadores.coordenadorEditing.idEstado > -1) {
          this.loadCidades(
            this.props.coordenadores.coordenadorEditing.idEstado
          );
        }
      });
    }

    this.setState({
      ...this.state,
      ...currState,
    });
  }

  getTitle() {
    if (this.editing()) {
      return this.props.languageValues.editCoordenadorModalTitle;
    }
    return this.props.languageValues.newCoordenadorModalTitle;
  }

  getSubmitLabel() {
    if (this.editing()) {
      return this.props.languageValues.salvar;
    }
    return this.props.languageValues.cadastrar;
  }

  setValue(event) {
    this.setState({
      ...this.state,
      [event.target.name + 'Changed']: true,
    });
    this.props.changeCoordenadorEditingValue(
      event.target.name,
      event.target.value
    );
  }

  simpleValidation(value) {
    return value && value.length > 0 ? true : false;
  }

  nomeIsValid(force) {
    if (force || this.state.focusedFieldName === 'nome') {
      const value = this.props.coordenadores.coordenadorEditing.nome;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.nome.required
      );
      const validation = doubleNameIsValid(
        value,
        this.props.languageValues.validations.nome.validation
      );
      if (!required.status) {
        this.validations.nomeIsValid = required;
        return required;
      }
      if (!validation.status) {
        this.validations.nomeIsValid = validation;
        return validation;
      }
      this.validations.nomeIsValid = {
        status: true,
      };
      return this.validations.nomeIsValid;
    } else {
      return this.validations.nomeIsValid;
    }
  }

  celularValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'celular') {
      const value = this.props.coordenadores.coordenadorEditing.celular;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.celular.required
      );
      const length = celularIsValid(
        value,
        this.props.languageValues.validations.celular.length
      );
      if (!required.status) {
        this.validations.celularIsValid = required;
        return this.validations.celularIsValid;
      }
      if (!length.status) {
        this.validations.celularIsValid = length;
        return this.validations.celularIsValid;
      }
      this.validations.celularIsValid = {
        status: true,
      };
      return this.validations.celularIsValid;
    } else {
      return this.validations.celularIsValid;
    }
  }

  dataNascimentoIsValid(force) {
    if (force || this.state.focusedFieldName === 'dataNascimento') {
      const value = this.props.coordenadores.coordenadorEditing.dataNascimento;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.birthDate.required
      );
      const validation = dateIsValid(
        value,
        this.props.languageValues.validations.birthDate.validation
      );
      if (!required.status) {
        this.validations.dataNascimentoIsValid = required;
        return this.validations.dataNascimentoIsValid;
      }
      if (!validation.status) {
        this.validations.dataNascimentoIsValid = validation;
        return this.validations.dataNascimentoIsValid;
      }
      this.validations.dataNascimentoIsValid = {
        status: true,
      };
      return this.validations.dataNascimentoIsValid;
    } else {
      return this.validations.dataNascimentoIsValid;
    }
  }

  emailValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'email') {
      const value = this.props.coordenadores.coordenadorEditing.email;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.email.required
      );
      const validation = emailIsValid(
        value,
        this.props.languageValues.validations.email.validation
      );
      if (!required.status) {
        this.validations.emailIsValid = required;
        return this.validations.emailIsValid;
      }
      if (!validation.status) {
        this.validations.emailIsValid = validation;
        return this.validations.emailIsValid;
      }
      this.validations.emailIsValid = {
        status: true,
      };
      return this.validations.emailIsValid;
    } else {
      return this.validations.emailIsValid;
    }
  }

  cpfValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'cpf') {
      const value = this.props.coordenadores.coordenadorEditing.cpf;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.cpf.required
      );
      const validation = cpfIsValid(
        value,
        this.props.languageValues.validations.cpf.validation
      );
      if (!required.status) {
        this.validations.cpfIsValid = required;
        return this.validations.cpfIsValid;
      }
      if (!validation.status) {
        this.validations.cpfIsValid = validation;
        return this.validations.cpfIsValid;
      }
      this.validations.cpfIsValid = {
        status: true,
      };
      return this.validations.cpfIsValid;
    } else {
      return this.validations.cpfIsValid;
    }
  }

  cooperativaValueIsValid() {
    return this.props.coordenadores.coordenadorEditing.coop.length > 0
      ? {
        status: true,
      }
      : {
        status: false,
        error: this.props.languageValues.validations.cooperativa.required,
      };
  }

  estadoValueIsValid() {
    const required = estadoRequiredIsValid(
      this.props.coordenadores.coordenadorEditing.idEstado,
      this.props.languageValues.validations.estado.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  cidadeFieldIsDisabled() {
    return this.props.logradouro.loadingCidades ||
      this.props.coordenadores.coordenadorEditing.idEstado === -1
      ? true
      : false;
  }

  cidadeValueIsValid() {
    const required = strCidadeRequiredIsValid(
      this.props.coordenadores.coordenadorEditing.cidade,
      this.props.languageValues.validations.cidade.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  processing() {
    return this.state.sending || this.state.loading ? true : false;
  }

  formIsValid(force) {
    const arr = [
      this.nomeIsValid(force).status,
      this.celularValueIsValid(force).status,
      this.dataNascimentoIsValid(force).status,
      this.emailValueIsValid(force).status,
      this.editing() ? true : this.cpfValueIsValid(force).status,
      this.cooperativaValueIsValid().status,
      this.estadoValueIsValid(force).status,
      this.cidadeValueIsValid(force).status,
    ];
    return allIsTrue(arr);
  }

  editing() {
    return this.props.cpf ? true : false;
  }

  toSubmit() {
    if (!this.formIsValid()) {
      return false;
    }

    this.changeState({
      saving: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
    });

    this.props.saveCoordenadorByCPF(
      {
        celular: getUnmaskedValue(
          this.props.coordenadores.coordenadorEditing.celular
        ),
        cpf: getUnmaskedValue(this.props.coordenadores.coordenadorEditing.cpf),
        dataNascimento: getUnmaskedValue(
          this.props.coordenadores.coordenadorEditing.dataNascimento
        ),
        email: this.props.coordenadores.coordenadorEditing.email.trim(),
        coop: this.props.coordenadores.coordenadorEditing.coop,
        codCoop: this.props.coordenadores.coordenadorEditing.coop,
        nome: this.props.coordenadores.coordenadorEditing.nome.trim(),
        estado: this.props.coordenadores.coordenadorEditing.estado,
        idEstado: this.props.coordenadores.coordenadorEditing.idEstado,
        cidade: this.props.coordenadores.coordenadorEditing.cidade,
        statusReq: this.editing()
          ? API_STATUS_REQ_UPDATE
          : API_STATUS_REQ_CREATE,
      },
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.editing()
            ? this.props.languageValues.successSalvarCoordenador
            : this.props.languageValues.successCadastrarCoordenador,
          options: {
            variant: 'success',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
        if (typeof this.props.savedCallback === 'function') {
          this.props.savedCallback();
        }
        this.toClose();
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message: error.response.statusText
            ? error.response.statusText
            : this.editing()
              ? this.props.languageValues.erroSalvarCoordenador
              : this.props.languageValues.erroCadastrarCoordenador,
          options: {
            variant: 'error',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
      }
    );
  }

  toClose() {
    this.props.closeModal(this.props.modalKey);
  }

  focusIn(fieldName) {
    this.setState({
      ...this.state,
      focusedFieldName: fieldName,
    });
  }

  focusOut(fieldName) {
    if (this.state.focusedFieldName === fieldName) {
      this.setState({
        ...this.state,
        focusedFieldName: null,
      });
    }
  }

  allowEdit() {
    return this.props.auth.userPermissions.coordenadores.edit;
  }

  render() {
    return (
      <GenericModalCadastro
        id={rootElementId}
        onClose={() => {
          this.toClose();
        }}
        DialogProps={{
          maxWidth: 'sm',
          disableBackdropClick: this.state.disableBackdropClick,
          disableEscapeKeyDown: this.state.disableEscapeKeyDown,
        }}
        title={
          <>
            {this.getTitle()}
            {this.state.loading || this.state.saving ? (
              <RefreshIcon className={rootClassName + '-loading-icon'} />
            ) : null}
          </>
        }
        footerContent={
          <>
            <Row>
              <Col cols={[12, 6, 6, 6, 6]} className='col-legend'>
                <div className='legend'>
                  {this.props.languageValues.campoObrigatorio}
                </div>
              </Col>
            </Row>
            <Row>
              <Col cols={[12, 12, 6, 6, 5]}>
                <CustomButton
                  id={getElementID(rootElementId, 'cancel')}
                  theme='pufvYellow'
                  className={rootClassName + '-cancel-button'}
                  label={this.props.languageValues.cancelButton}
                  onClick={() => this.toClose()}
                />
              </Col>
              <Col cols={[12, 12, 6, 6, 4]}>
                <CustomButton
                  id={getElementID(rootElementId, 'save')}
                  theme='pufvYellow'
                  className={rootClassName + '-save-buttom'}
                  label={this.getSubmitLabel()}
                  disabled={
                    this.state.loading ||
                    this.state.saving ||
                    !this.formIsValid()
                  }
                  rightIcon={<SaveIcon />}
                  type='submit'
                />
              </Col>
            </Row>
          </>
        }
        onSubmit={(event) => {
          event.preventDefault();
          this.toSubmit();
        }}
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'nome')}
              label={this.props.languageValues.cadastroCoordenadorNome}
              name='nome'
              value={this.props.coordenadores.coordenadorEditing.nome || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={NOME_MAX_LENGTH}
              helperText={
                this.state.nomeChanged && !this.nomeIsValid().status
                  ? this.nomeIsValid().error
                  : ''
              }
              error={this.state.nomeChanged && !this.nomeIsValid().status}
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'email')}
              label={this.props.languageValues.cadastroCoordenadorEmail}
              name='email'
              value={this.props.coordenadores.coordenadorEditing.email || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={EMAIL_MAX_LENGTH}
              helperText={
                this.state.emailChanged && !this.emailValueIsValid().status
                  ? this.emailValueIsValid().error
                  : ''
              }
              error={
                this.state.emailChanged && !this.emailValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'data-nascimento')}
              label={
                this.props.languageValues.cadastroCoordenadorDataNascimento
              }
              name='dataNascimento'
              value={
                this.props.coordenadores.coordenadorEditing.dataNascimento || ''
              }
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                this.state.dataNascimentoChanged &&
                  !this.dataNascimentoIsValid().status
                  ? this.dataNascimentoIsValid().error
                  : ''
              }
              error={
                this.state.dataNascimentoChanged &&
                !this.dataNascimentoIsValid().status
              }
              disabled={this.fieldDisabled()}
              InputProps={{
                inputComponent: DateMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'celular')}
              label={this.props.languageValues.cadastroCoordenadorCelular}
              name='celular'
              value={this.props.coordenadores.coordenadorEditing.celular || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                this.state.celularChanged && !this.celularValueIsValid().status
                  ? this.celularValueIsValid().error
                  : ''
              }
              error={
                this.state.celularChanged && !this.celularValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              InputProps={{
                inputComponent: PhoneMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'cpf')}
              label={this.props.languageValues.cadastroCoordenadorCPF}
              name='cpf'
              value={this.props.coordenadores.coordenadorEditing.cpf || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                !this.editing() &&
                  this.state.cpfChanged &&
                  !this.cpfValueIsValid().status
                  ? this.cpfValueIsValid().error
                  : ''
              }
              error={
                !this.editing() &&
                this.state.cpfChanged &&
                !this.cpfValueIsValid().status
              }
              disabled={this.editing() || this.fieldDisabled()}
              InputProps={{
                inputComponent: CPFMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                id={'cooperativa-id'}
                label={this.props.languageValues.cadastroCoordenadorCooperativa}
                placeholder={
                  this.props.logradouro.loadingCooperativas
                    ? this.props.languageValues.loadingCooperativas
                    : ''
                }
                options={this.props.logradouro.cooperativas.map((item) => {
                  return {
                    label: item.nome,
                    value: item.codigo,
                  };
                })}
                value={this.props.coordenadores.coordenadorEditing.coop}
                onChange={(value) => {
                  const currValue =
                    value && value.value > -1 ? value.value : '';
                  this.setValue({
                    target: {
                      name: 'coop',
                      value: currValue,
                    },
                  });
                }}
                loading={this.props.logradouro.loadingCooperativas}
                loadingMessage={this.props.languageValues.loadingCooperativas}
                disabled={
                  this.fieldDisabled() ||
                  this.props.logradouro.loadingCooperativas
                }
                error={
                  this.state.coopChanged &&
                  !this.cooperativaValueIsValid().status
                }
                helperText={
                  this.state.coopChanged &&
                    !this.cooperativaValueIsValid().status
                    ? this.cooperativaValueIsValid().error
                    : ''
                }
                data-test='cooperativa-id'
              />
            </Col>
          </Row>
        ) : null}
        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 6, 6, 6, 6]}>
              <NewAutoCompleteFieldEstados
                id={getElementID(rootElementId, 'estado')}
                label={this.props.languageValues.cadastroCoordenadorEstado}
                placeholder={
                  this.props.logradouro.loadingEstados
                    ? this.props.languageValues.loadingEstados
                    : ''
                }
                options={this.props.logradouro.estados.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                    sigla: item.sigla,
                  };
                })}
                value={this.props.coordenadores.coordenadorEditing.idEstado}
                onChange={(value) => {
                  const currValue =
                    value && value.value > -1 ? value.value : -1;
                  this.setValue({
                    target: {
                      name: 'idEstado',
                      value: currValue,
                    },
                  });
                  this.setValue({
                    target: {
                      name: 'estado',
                      value: value && value.value > -1 ? value.label : '',
                    },
                  });
                  this.setValue({
                    target: {
                      name: 'cidade',
                      value: -1,
                    },
                  });
                  window.setTimeout(() => {
                    this.setValue({
                      target: {
                        name: 'idEstado',
                        value: currValue,
                      },
                    });
                  }, 1);
                  if (currValue > -1) {
                    this.loadCidades(currValue);
                  }
                }}
                loading={this.props.logradouro.loadingEstados}
                loadingMessage={this.props.languageValues.loadingEstados}
                disabled={
                  this.fieldDisabled() || this.props.logradouro.loadingEstados
                }
                error={
                  this.state.estadoChanged && !this.estadoValueIsValid().status
                }
                helperText={
                  this.state.estadoChanged && !this.estadoValueIsValid().status
                    ? this.estadoValueIsValid().error
                    : ''
                }
              />
            </Col>
            <Col cols={[12, 6, 6, 6, 6]}>
              <NewAutoCompleteFieldCidades
                id={getElementID(rootElementId, 'cidade')}
                label={this.props.languageValues.cadastroCoordenadorCidade}
                placeholder={
                  this.props.logradouro.loadingCidades
                    ? this.props.languageValues.loadingCidades
                    : ''
                }
                options={this.getCidades(
                  this.getUFByIdEstado(
                    this.props.coordenadores.coordenadorEditing.idEstado
                  )
                ).map((item) => {
                  return {
                    label: item.nome,
                    value: item.nome,
                  };
                })}
                value={this.props.coordenadores.coordenadorEditing.cidade}
                onChange={(value) => {
                  const currValue =
                    value && value.value > '' ? value.value : '';
                  this.setValue({
                    target: {
                      name: 'cidade',
                      value: currValue,
                    },
                  });
                }}
                loading={this.props.logradouro.loadingCidades}
                loadingMessage={this.props.languageValues.loadingCidades}
                disabled={this.cidadeFieldIsDisabled()}
                helperText={
                  this.state.cidadeChanged && !this.cidadeValueIsValid().status
                    ? this.cidadeValueIsValid().error
                    : ''
                }
                error={
                  this.state.cidadeChanged && !this.cidadeValueIsValid().status
                }
              />
            </Col>
          </Row>
        ) : null}
      </GenericModalCadastro>
    );
  }
}

CoordenadorEditModal.propTypes = {
  cpf: PropTypes.string,
  modalKey: PropTypes.string.isRequired,
  savedCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  coordenadores: state.coordenadores,
  logradouro: state.logradouro,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeCoordenadorEditingValue,
      loadCooperativas,
      clearCoordenadorEditing,
      closeModal,
      loadCoordenadorByCPF,
      saveCoordenadorByCPF,
      loadEstados,
      loadCidadesByEstadoId,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoordenadorEditModal);
